module.exports = __webpack_public_path__ + "img/水星.fb46ac42.svg";